import { Buffer } from "buffer";
/**
 * ファイルbase64デコード部品
 * ファイル名、ファイルデータ(base64)引数にとって、結果コードとファイルデータを返す
 *
 * @param fileName : ファイル名
 * @param fileData : base64変換されたファイルデータ
 * @return resultdecodeInfo : 結果コード(メッセージID)、ファイルデータ
 **/

export function decodeBase64(fileName: string, fileData: string) {
  const resultdecodeInfo = {
    messeageid: "",
    base64decoderesult: "",
  };

  if (fileName === "" || fileData === "") {
    resultdecodeInfo.messeageid = "TKMSG_SCR0007E";
    return resultdecodeInfo;
  }

  const extension = fileName.split(".").pop();
  const decodedata = Buffer.from(fileData, "base64");
  //extensionは使用する前にチェックしているため!を使用している。
  const resultdecodeFiledata = decodedata + extension!;
  resultdecodeInfo.base64decoderesult = resultdecodeFiledata;
  return resultdecodeInfo;
}
